export const TASK_LIST_GENERIC_ACTIVITY_LIST_SORT = 'TASK_LIST_GENERIC_ACTIVITY_LIST_SORT';

export const TASK_LIST_GENERIC_ACTIVITY_LIST_VIEW_MODE_LARGE = 'TASK_LIST_GENERIC_ACTIVITY_LIST_VIEW_MODE_LARGE';
